/**
 * @namespace FairSchedulingAPI
 */
window.FairSchedulingAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    self.updateBrandRightToRestSettings = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/right_to_rest', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateBrandPenaltySettings = function (brandId, payload) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/penalty', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandRightToRestSettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/right_to_rest', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandPenaltySettings = function (brandId) {
        var deferred = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/settings/penalty', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandPenaltiesLookup = function (brandId, penaltyIds, rightToRestPenaltyIds) {
        var deferred = $q.defer();

        if(!brandId) {
            throw "No brand id";
        }

        var params = {};

        if (penaltyIds && penaltyIds.length) {
            params.penalty_ids = penaltyIds.join(",");
        }

        if (rightToRestPenaltyIds && rightToRestPenaltyIds.length) {
            params.right_to_rest_penalty_ids = rightToRestPenaltyIds.join(",");
        }

        _protected.request('brands/' + brandId + '/penalties/lookups', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
});
